module.exports = __webpack_public_path__ + "img/354.d446dfc2.jpg";